import script from "./InfoIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoIcon.vue?vue&type=script&setup=true&lang=js"

import "./InfoIcon.vue?vue&type=style&index=0&id=1331d628&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1331d628"]])

export default __exports__